import angular from 'angular';

angular.module('commonServices').filter('showAddressData', function() {
  var formatAddress = function(a) {
    if ((a.medium === 0 || a.medium === 5) && a.postAddress) {
      var postAddress = a.postAddress;
      return (
        postAddress.street1 +
        ' ' +
        (postAddress.number ? postAddress.number : '') +
        (postAddress.box ? '/' + postAddress.box + ' ' : '') +
        (postAddress.street2 ? ' - ' + postAddress.street2 + ' ' : '') +
        ' - ' +
        (postAddress.zipCode ? postAddress.zipCode + ' ' : '') +
        (postAddress.city || '')
      );
    }
    return a.addressData;
  };

  return function(address, addressList) {
    if (!address) return null;
    if (address.addressData || address.postAddress) return formatAddress(address);
    if (!addressList || !angular.isArray(addressList)) return null;

    for (var t = 0; t < addressList.length; t++)
      if (addressList[t].id === address) return formatAddress(addressList[t]);
    return null;
  };
});
